export default __webpack_public_path__ + "static/media/group-580@2x.2a0a6061.png";